export default __webpack_public_path__ + "static/media/Refined Pharmacon of Negation.d677ebc7.jpg";